import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';
import EarningsWidgetComponent from './earnings-widget-component';
import NetEarningsWidgetComponent from './net-earnings-widget-component';
import EarningsHistoryComponent from './components/earnings-history-component';

export default angular
  .module('earnings-widget', [])
  .component('earningsWidget', new EarningsWidgetComponent())
  .component('netEarningsWidget', new NetEarningsWidgetComponent())
  .component('earningsHistory', new EarningsHistoryComponent())
  .config([
    '$stateProvider',
    function configuration($stateProvider) {
      $stateProvider
        .state('earnings-history', {
          parent: 'arw',
          url: '/earnings/history/:retailerNo?',
          template: '<earnings-history></earnings-history>',
          redirectTo: 'permissions-denied',
          params: {
            pageTitle: [
              '$ngRedux',
              'gettextCatalog',
              ($ngRedux, gettextCatalog) => {
                $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Earnings History')));
              },
            ],
          },
        })
        .state('netearnings-history', {
          parent: 'arw',
          url: '/earnings/history/:retailerNo?',
          template: '<earnings-history></earnings-history>',
          redirectTo: 'permissions-denied',
          params: {
            pageTitle: [
              '$ngRedux',
              'gettextCatalog',
              ($ngRedux, gettextCatalog) => {
                $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Earnings History')));
              },
            ],
          },
        });
    },
  ]);



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/earnings/earnings-widget-module.js